<script>
import editPropertyModal from "../modals/modal-edit-property";
import deletePropertyModal from "../../components/modals/modal-delete-property";

export default {
  name: "accountProperties",
  components: {
    editPropertyModal,
    deletePropertyModal,
  },
  methods: {
    editProperty: function (p, notEditable) {
      this.$refs.editpropertyModal.editProperty(p, notEditable);
    },
    getAllProperties: async function () {
      this.properties = await this.$A.AccountService.GetAllCustomProofProperties() || [];
      this.loaded = true;
    },
  },
  computed: {
    displayFeatureBtn: function () {
      const properties = _.get(this, 'properties', [])
      return !this.isEnterpriseAccount && properties.length > 0;
    }
  },
  data() {
    return {
      properties: [],
      loaded: false,
      isEnterpriseAccount: false,
    };
  },
  async mounted() {
    await this.getAllProperties()
    this.isEnterpriseAccount = _.get(this.$A, 'Auth.account.subscriptionState.sku', []).includes('enterprise') || _.get(this.$A, 'Auth.account.subscriptionState.sku', []).includes('premium');
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Proof Properties</div>
      <div class="card-head-subtitle">Properties are used to collect and store information about your proofs. For example, a proof might have properties like P.O. Number or Company.</div>
    </div>

    <div class="property-rows" v-if="properties.length">
      <div class="property-row property-row-head">
        <span class="property-col-label">Custom Field</span>
        <span class="property-col-type">Field Type</span>
        <span class="property-col-actions"></span>
      </div>
      <div class="property-row" v-for="property in properties" :key="property.id">
        <span class="property-col-label property-name">{{ property.label }}</span>
        <span class="property-col-type">
          <span class="type-chip">{{ property.dataType }}</span>
        </span>
        <span class="property-col-actions">
          <a
              v-if="property.dataType === 'Dropdown Select' || property.dataType === 'Checkboxes (Multiple Options)'"
              class="action-link"
              @click="editProperty(property, true)">Edit</a>
          <a class="action-link action-danger"
             @click="$refs.deletepropertyModal.open(property)">Delete</a>
        </span>
      </div>
    </div>

    <div v-if="loaded && !properties.length" class="list-empty">
      <div class="empty-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6" />
          <line x1="8" y1="12" x2="21" y2="12" />
          <line x1="8" y1="18" x2="21" y2="18" />
          <line x1="3" y1="6" x2="3.01" y2="6" />
          <line x1="3" y1="12" x2="3.01" y2="12" />
          <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
      </div>
      <div class="empty-title">No custom properties yet</div>
      <div class="empty-text">Capture the fields that matter to your team — like P.O. Number or Client — on every proof you create.</div>
      <a @click="editProperty" class="primary-btn empty-cta">Create Property</a>
    </div>

    <editPropertyModal ref="editpropertyModal" v-on:propertySaved="getAllProperties"/>
    <deletePropertyModal ref="deletepropertyModal" v-on:propertyDeleted="getAllProperties"/>

    <div class="card-foot" v-if="properties.length">
      <a @click="editProperty" class="primary-btn"
         v-if="!displayFeatureBtn">Create Property</a>
      <b-button v-if="displayFeatureBtn"
                class="locked-btn"
                @click="$A.BuyNow()"
                v-b-tooltip.hover="'Upgrade to add more fields'">
        Feature Locked <img src="/img/feature-lock.svg" class="feature-icon ml-2"/>
      </b-button>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}

/* Rows */
.property-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 13px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.property-row:last-child {
  border-bottom: 0;
}
.property-row:not(.property-row-head):hover {
  background: #f9f9fa;
}
.property-row-head {
  padding: 9px 20px;
  background: #fbfbfc;
}
.property-row-head span {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.property-col-label {
  flex: 1;
  min-width: 0;
}
.property-col-type {
  width: 240px;
  flex-shrink: 0;
}
.property-col-actions {
  width: 110px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}
.property-name {
  font-size: 13.5px;
  font-weight: 500;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.type-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 11px;
  font-weight: 600;
}
.action-link {
  font-size: 12.5px;
  font-weight: 600;
  color: #019256;
  cursor: pointer;
  text-decoration: none;
}
.action-link:hover {
  color: #017a48;
  text-decoration: none;
}
.action-danger {
  color: #b43643;
}
.action-danger:hover {
  color: #8f2a35;
}

/* Empty state */
.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 32px;
}
.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: rgba(1, 146, 86, 0.1);
  color: #019256;
  margin-bottom: 14px;
}
.empty-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}
.empty-text {
  margin-top: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.55;
  max-width: 360px;
}
.empty-cta {
  margin-top: 16px;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.locked-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #F44271;
  border: 0;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
}
.locked-btn:hover,
.locked-btn:focus,
.locked-btn:active {
  background: #F44271 !important;
  opacity: 0.9;
  color: #fff;
}
.feature-icon {
  height: 14px;
}

@media (max-width: 767px) {
  .property-col-type {
    width: auto;
  }
  .property-row {
    flex-wrap: wrap;
    gap: 8px;
  }
  .property-col-label {
    flex-basis: 100%;
  }
  .property-col-actions {
    margin-left: auto;
  }
  .primary-btn,
  .locked-btn {
    flex: 1;
  }
}
</style>
